import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'

const clockData = [
  { id:1,  name:'Jamie Mitchell',  initials:'JM', dept:'Operations',      status:'in',  clockIn:'8:02 AM',  clockOut:null,      hours:null, code:'OPS-001', note:'Morning shift' },
  { id:2,  name:'Sam Rivera',      initials:'SR', dept:'Operations',      status:'in',  clockIn:'8:15 AM',  clockOut:null,      hours:null, code:'OPS-001', note:'' },
  { id:3,  name:'Kim Park',        initials:'KP', dept:'Administrative',  status:'in',  clockIn:'9:00 AM',  clockOut:null,      hours:null, code:'ADM-002', note:'Budget review' },
  { id:4,  name:'Dana Lee',        initials:'DL', dept:'Field Staff',     status:'out', clockIn:'7:30 AM',  clockOut:'12:00 PM',hours:4.5,  code:'FLD-003', note:'' },
  { id:5,  name:'Marcus Thomas',   initials:'MT', dept:'Operations',      status:'out', clockIn:'8:45 AM',  clockOut:'11:30 AM',hours:2.75, code:'OPS-001', note:'Left early' },
  { id:6,  name:'Jordan Collins',  initials:'JC', dept:'Field Staff',     status:'in',  clockIn:'7:00 AM',  clockOut:null,      hours:null, code:'FLD-003', note:'' },
  { id:7,  name:'Paula Reyes',     initials:'PR', dept:'Customer Service',status:'out', clockIn:'8:00 AM',  clockOut:'5:00 PM', hours:9.0,  code:'CS-004',  note:'OT approved' },
  { id:8,  name:'Tyler Walsh',     initials:'TW', dept:'Administrative',  status:'none',clockIn:null,       clockOut:null,      hours:null, code:'',        note:'' },
  { id:9,  name:'Lena Fischer',    initials:'LF', dept:'Field Staff',     status:'in',  clockIn:'6:45 AM',  clockOut:null,      hours:null, code:'FLD-003', note:'Early shift' },
  { id:10, name:'Marcus Webb',     initials:'MW', dept:'Operations',      status:'in',  clockIn:'8:30 AM',  clockOut:null,      hours:null, code:'OPS-002', note:'' },
]

export default function Approvals() {
  const { accent, accentLight, accentBg } = useBrandColors()
  const [tab, setTab] = useState('pto')
  const [ptoRequests, setPtoRequests] = useState([
    { id: 0, name: 'Jamie Mitchell', initials: 'JM', dates: 'Apr 23-25', type: 'Vacation',  hours: 24, balance: 4,  status: 'pending' },
    { id: 1, name: 'Sam Rivera',     initials: 'SR', dates: 'Apr 18-19', type: 'Vacation',  hours: 16, balance: 6,  status: 'pending' },
    { id: 2, name: 'Dana Lee',       initials: 'DL', dates: 'Apr 10',    type: 'Sick',      hours: 8,  balance: 10, status: 'pending' },
    { id: 3, name: 'Kim Park',       initials: 'KP', dates: 'May 1-2',   type: 'Personal',  hours: 8,  balance: 9,  status: 'pending' },
  ])
  const [timesheets, setTimesheets] = useState([
    { id: 0, name: 'Jamie Mitchell', initials: 'JM', week: 'Wk 13', hours: 40.0, ot: 0,   status: 'pending' },
    { id: 1, name: 'Sam Rivera',     initials: 'SR', week: 'Wk 13', hours: 38.5, ot: 0,   status: 'pending' },
    { id: 2, name: 'Kim Park',       initials: 'KP', week: 'Wk 13', hours: 42.5, ot: 2.5, status: 'pending' },
    { id: 3, name: 'Dana Lee',       initials: 'DL', week: 'Wk 13', hours: 40.0, ot: 0,   status: 'pending' },
    { id: 4, name: 'Marcus Thomas',  initials: 'MT', week: 'Wk 13', hours: 36.0, ot: 0,   status: 'pending' },
    { id: 5, name: 'Paula Reyes',    initials: 'PR', week: 'Wk 13', hours: 40.0, ot: 0,   status: 'pending' },
  ])
  const [clockFilter, setClockFilter] = useState('All')
  const [toast, setToast] = useState(null)

  function actPTO(id, approve) {
    setPtoRequests(prev => prev.map(r => r.id === id ? {...r, status: approve ? 'approved' : 'denied'} : r))
    const name = ptoRequests.find(r => r.id === id)?.name
    setToast(approve ? `${name}'s time off approved.` : `${name}'s time off denied.`)
    setTimeout(() => setToast(null), 3000)
  }
  function actTS(id, approve) {
    setTimesheets(prev => prev.map(r => r.id === id ? {...r, status: approve ? 'approved' : 'denied'} : r))
    const name = timesheets.find(r => r.id === id)?.name
    setToast(approve ? `${name}'s timesheet approved.` : `${name}'s timesheet sent back.`)
    setTimeout(() => setToast(null), 3000)
  }

  const ptoPending = ptoRequests.filter(r => r.status === 'pending').length
  const tsPending  = timesheets.filter(r => r.status === 'pending').length
  const clockedInNow = clockData.filter(e => e.status === 'in').length

  const filteredClock = clockFilter === 'All' ? clockData
    : clockFilter === 'In' ? clockData.filter(e => e.status === 'in')
    : clockFilter === 'Out' ? clockData.filter(e => e.status === 'out')
    : clockData.filter(e => e.status === 'none')

  function calcElapsed(clockIn) {
    if (!clockIn) return '--'
    const [time, ampm] = clockIn.split(' ')
    const [h, m] = time.split(':').map(Number)
    let hours = h + (ampm === 'PM' && h !== 12 ? 12 : 0)
    if (ampm === 'AM' && h === 12) hours = 0
    const inDate = new Date()
    inDate.setHours(hours, m, 0)
    const now = new Date()
    now.setHours(10, 32, 0)
    const diff = Math.max(0, (now - inDate) / 3600000)
    return diff.toFixed(2) + 'h'
  }

  const av = (initials, color) => (
    <div style={{width:28,height:28,borderRadius:'50%',background:(color||accent)+'22',color:color||accent,display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:700,flexShrink:0}}>{initials}</div>
  )

  const tabs = [
    { key:'pto',   label:'Time Off',   badge: ptoPending },
    { key:'ts',    label:'Timesheets', badge: tsPending  },
    { key:'clock', label:'Time Clock', badge: clockedInNow },
  ]

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>
      <div style={{marginBottom:20}}>
        <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>Approvals</h1>
        <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Review and action pending requests</p>
      </div>

      {/* Tab bar */}
      <div style={{display:'flex',background:'#fff',border:'1px solid #EDE6DA',borderRadius:8,overflow:'hidden',marginBottom:16,width:'fit-content'}}>
        {tabs.map((t,i)=>(
          <button key={t.key} onClick={()=>setTab(t.key)}
            style={{padding:'8px 24px',border:'none',borderRight:i<tabs.length-1?'1px solid #EDE6DA':'none',background:tab===t.key?accent:'#fff',color:tab===t.key?'#fff':'#4A4A4A',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",transition:'all 0.15s',position:'relative'}}>
            {t.label}
            <span style={{marginLeft:6,padding:'1px 6px',borderRadius:8,fontSize:10,fontWeight:700,
              background:tab===t.key?'rgba(255,255,255,0.25)':(t.key==='clock'?'rgba(74,124,89,0.1)':accentBg),
              color:tab===t.key?'#fff':(t.key==='clock'?'#4A7C59':accent)}}>
              {t.badge}
            </span>
          </button>
        ))}
      </div>

      {toast && (
        <div style={{display:'flex',alignItems:'center',gap:8,background:'rgba(74,124,89,0.1)',border:'1px solid #4A7C59',borderRadius:8,padding:'10px 14px',marginBottom:14}}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#4A7C59" strokeWidth="1.5"/><path d="M5 8l2 2 4-4" stroke="#4A7C59" strokeWidth="1.5" strokeLinecap="round"/></svg>
          <span style={{fontSize:12,color:'#4A7C59',fontWeight:500}}>{toast}</span>
        </div>
      )}

      {/* Time Off Tab */}
      {tab === 'pto' && (
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Time Off Requests</div>
              <span style={{padding:'2px 8px',borderRadius:8,fontSize:10,fontWeight:600,background:accentBg,color:accent}}>{ptoPending} pending</span>
            </div>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
              <thead>
                <tr style={{background:'#F7F2EB'}}>
                  {['Employee','Dates','Type','Hrs','Bal.(hrs)',''].map(h => (
                    <th key={h} style={{textAlign:'left',padding:'8px 12px',fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,borderBottom:'1px solid #EDE6DA'}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ptoRequests.map(r => (
                  <tr key={r.id} style={{borderBottom:'1px solid #EDE6DA',opacity:r.status!=='pending'?0.5:1}}>
                    <td style={{padding:'10px 12px'}}>
                      <div style={{display:'flex',alignItems:'center',gap:6}}>{av(r.initials)}<span style={{fontWeight:500,color:'#2B2B2B'}}>{r.name.split(' ')[0]}</span></div>
                    </td>
                    <td style={{padding:'10px 12px',color:'#4A4A4A'}}>{r.dates}</td>
                    <td style={{padding:'10px 12px',color:'#4A4A4A'}}>{r.type}</td>
                    <td style={{padding:'10px 12px',color:'#4A4A4A',fontWeight:500}}>{r.hours}</td>
                    <td style={{padding:'10px 12px'}}>
                      <span style={{color: r.balance < r.hours ? '#A0392B' : '#4A4A4A', fontWeight: r.balance < r.hours ? 600 : 400}}>
                        {r.balance} {r.balance < r.hours && '⚠'}
                      </span>
                    </td>
                    <td style={{padding:'10px 12px'}}>
                      {r.status === 'pending' ? (
                        <div style={{display:'flex',gap:6}}>
                          <button onClick={()=>actPTO(r.id,true)} style={{padding:'3px 8px',background:'rgba(74,124,89,0.1)',border:'1px solid #4A7C59',borderRadius:4,color:'#4A7C59',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>✓</button>
                          <button onClick={()=>actPTO(r.id,false)} style={{padding:'3px 8px',background:'rgba(160,57,43,0.08)',border:'1px solid #A0392B',borderRadius:4,color:'#A0392B',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>✕</button>
                        </div>
                      ) : (
                        <span style={{fontSize:11,fontWeight:600,color:r.status==='approved'?'#4A7C59':'#A0392B'}}>{r.status==='approved'?'✓ Approved':'Denied'}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'16px',display:'flex',flexDirection:'column',gap:10}}>
            <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B',marginBottom:4}}>Quick Summary</div>
            {[['Pending Requests', ptoPending, accent],['Approved This Month','8','#4A7C59'],['Denied This Month','2','#A0392B'],['Total Hours Requested','56','#4A6B8A']].map(([l,v,c])=>(
              <div key={l} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px 12px',background:'#F7F2EB',borderRadius:6}}>
                <span style={{fontSize:12,color:'#4A4A4A'}}>{l}</span>
                <span style={{fontFamily:'Georgia,serif',fontSize:16,fontWeight:600,color:c}}>{v}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Timesheets Tab */}
      {tab === 'ts' && (
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Timesheets</div>
            <span style={{padding:'2px 8px',borderRadius:8,fontSize:10,fontWeight:600,background:accentBg,color:accent}}>{tsPending} pending</span>
          </div>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
            <thead>
              <tr style={{background:'#F7F2EB'}}>
                {['Employee','Week','Hours','OT',''].map(h => (
                  <th key={h} style={{textAlign:'left',padding:'8px 12px',fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,borderBottom:'1px solid #EDE6DA'}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {timesheets.map(r => (
                <tr key={r.id} style={{borderBottom:'1px solid #EDE6DA',opacity:r.status!=='pending'?0.5:1}}>
                  <td style={{padding:'10px 12px'}}>
                    <div style={{display:'flex',alignItems:'center',gap:6}}>{av(r.initials)}<span style={{fontWeight:500,color:'#2B2B2B'}}>{r.name.split(' ')[0]}</span></div>
                  </td>
                  <td style={{padding:'10px 12px',color:'#4A4A4A'}}>{r.week}</td>
                  <td style={{padding:'10px 12px',color:'#4A4A4A'}}>{r.hours.toFixed(1)}</td>
                  <td style={{padding:'10px 12px'}}>
                    {r.ot > 0
                      ? <span style={{padding:'1px 6px',borderRadius:8,fontSize:10,fontWeight:600,background:'rgba(196,132,58,0.1)',color:'#C4843A'}}>+{r.ot.toFixed(1)}</span>
                      : <span style={{color:'#8A9E8A'}}>--</span>}
                  </td>
                  <td style={{padding:'10px 12px'}}>
                    {r.status === 'pending' ? (
                      <div style={{display:'flex',gap:6}}>
                        <button onClick={()=>actTS(r.id,true)} style={{padding:'3px 8px',background:'rgba(74,124,89,0.1)',border:'1px solid #4A7C59',borderRadius:4,color:'#4A7C59',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>✓</button>
                        <button onClick={()=>actTS(r.id,false)} style={{padding:'3px 8px',background:'rgba(160,57,43,0.08)',border:'1px solid #A0392B',borderRadius:4,color:'#A0392B',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>✕</button>
                      </div>
                    ) : (
                      <span style={{fontSize:11,fontWeight:600,color:r.status==='approved'?'#4A7C59':'#A0392B'}}>{r.status==='approved'?'✓ Approved':'Denied'}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Time Clock Tab */}
      {tab === 'clock' && (
        <div style={{display:'flex',flexDirection:'column',gap:14}}>

          {/* Live stats */}
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10}}>
            {[
              {label:'Currently Clocked In', value:clockedInNow, color:'#4A7C59'},
              {label:'Clocked Out Today',    value:clockData.filter(e=>e.status==='out').length, color:accent},
              {label:'Not Yet Clocked In',   value:clockData.filter(e=>e.status==='none').length, color:'#A0392B'},
              {label:'OT Flagged',           value:clockData.filter(e=>e.hours&&e.hours>8).length, color:'#C4843A'},
            ].map(s=>(
              <div key={s.label} style={{background:'#fff',border:`1px solid ${s.color}22`,borderRadius:10,padding:'12px 16px'}}>
                <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:500,marginBottom:4}}>{s.label}</div>
                <div style={{fontFamily:'Georgia,serif',fontSize:'1.6rem',color:s.color,fontWeight:600}}>{s.value}</div>
              </div>
            ))}
          </div>

          {/* Filter + table */}
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',justifyContent:'space-between',gap:8}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Today's Time Clock &mdash; April 2, 2025</div>
              <div style={{display:'flex',gap:6}}>
                {['All','In','Out','None'].map(f=>(
                  <button key={f} onClick={()=>setClockFilter(f)}
                    style={{padding:'4px 12px',border:`1px solid ${clockFilter===f?accent:'#EDE6DA'}`,borderRadius:20,background:clockFilter===f?accent:'#fff',color:clockFilter===f?'#fff':'#4A4A4A',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                    {f === 'None' ? 'Not In' : f}
                  </button>
                ))}
              </div>
            </div>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
              <thead>
                <tr style={{background:'#F7F2EB'}}>
                  {['Employee','Department','Status','Clock In','Clock Out','Code','Hours','Notes'].map(h=>(
                    <th key={h} style={{textAlign:'left',padding:'8px 14px',fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,borderBottom:'1px solid #EDE6DA'}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredClock.map(e=>(
                  <tr key={e.id} style={{borderBottom:'1px solid #EDE6DA'}}
                    onMouseEnter={ev=>ev.currentTarget.style.background='rgba(184,115,74,0.03)'}
                    onMouseLeave={ev=>ev.currentTarget.style.background='transparent'}>
                    <td style={{padding:'11px 14px'}}>
                      <div style={{display:'flex',alignItems:'center',gap:8}}>
                        {av(e.initials, e.status==='in'?'#4A7C59':e.status==='out'?accent:'#8A9E8A')}
                        <span style={{fontWeight:600,color:'#2B2B2B'}}>{e.name}</span>
                      </div>
                    </td>
                    <td style={{padding:'11px 14px',color:'#6B7D6B'}}>{e.dept}</td>
                    <td style={{padding:'11px 14px'}}>
                      {e.status === 'in'
                        ? <span style={{display:'inline-flex',alignItems:'center',gap:5,fontSize:11,fontWeight:600,color:'#4A7C59'}}>
                            <span style={{width:7,height:7,borderRadius:'50%',background:'#4A7C59',display:'inline-block'}}></span>Clocked In
                          </span>
                        : e.status === 'out'
                        ? <span style={{fontSize:11,fontWeight:600,color:'#6B7D6B'}}>Clocked Out</span>
                        : <span style={{fontSize:11,color:'#A0392B',fontWeight:600}}>Not In</span>
                      }
                    </td>
                    <td style={{padding:'11px 14px',color:'#4A4A4A',fontWeight:500}}>{e.clockIn || '--'}</td>
                    <td style={{padding:'11px 14px',color:'#4A4A4A'}}>{e.clockOut || (e.status==='in'?<span style={{color:'#4A7C59',fontWeight:600,fontSize:10}}>Active</span>:'--')}</td>
                    <td style={{padding:'11px 14px'}}>
                      {e.code
                        ? <span style={{fontSize:10,padding:'2px 6px',borderRadius:4,background:'rgba(74,107,138,0.08)',color:'#4A6B8A',fontWeight:600}}>{e.code}</span>
                        : <span style={{color:'#8A9E8A'}}>--</span>}
                    </td>
                    <td style={{padding:'11px 14px',fontWeight:600,color:e.hours&&e.hours>8?'#C4843A':'#2B2B2B'}}>
                      {e.status==='in' ? <span style={{color:'#4A7C59'}}>{calcElapsed(e.clockIn)}</span>
                       : e.hours ? e.hours.toFixed(2)+'h' : '--'}
                    </td>
                    <td style={{padding:'11px 14px',color:'#8A9E8A',fontSize:11}}>{e.note || '--'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  )
}
